var module; UMD(module, {
  'minted:m': ['M']
})(this, function (m_module) {

var M = m_module.M;

M.Config = M.Config || {};

M.Config['ChallengeConfig'] =
{
  "challenge_milestones_sort_by_string": {
    "win_count_desc": "win_count_desc",
    "announced_at_desc": "announced_at_desc"
  },
  "state": {
    "vote_closed": {
      "id": 2
    },
    "restricted_vote_closed": {
      "id": 51
    },
    "submission": {
      "id": 0
    },
    "nominate": {
      "id": 20
    },
    "setup": {
      "id": 10
    },
    "nominate_select": {
      "id": 30
    },
    "restricted_vote": {
      "id": 50
    },
    "published": {
      "id": 3
    },
    "vote": {
      "id": 1
    },
    "submission_closed": {
      "id": 40
    }
  },
  "url_fragments": {
    "special_prizes": "specialPrizes",
    "winners": "winners",
    "submissions": "submissions"
  },
  "sort_by_string": {
    "publish_date_desc": "publish_date_desc"
  },
  "winners_type": {
    "special_prize_winner": "specialPrizeWinner",
    "winner": "winner",
    "first_place": "firstPlace",
    "editors_pick": "editorsPick"
  },
  "state_query_string_types": {
    "all": {
      "query_param_val": "all",
      "filter_class": [
        ""
      ]
    },
    "restricted_voting_closed": {
      "query_param_val": "restricted_voting_closed",
      "filter_class": [
        "restrictedVotingClosed"
      ]
    },
    "restricted_vote": {
      "query_param_val": "restricted_vote",
      "filter_class": [
        "inRestrictedVoting"
      ]
    },
    "submit": {
      "query_param_val": "submit",
      "filter_class": [
        "openForSubmission"
      ]
    },
    "critique": {
      "query_param_val": "critique",
      "filter_class": [
        "openForCritique"
      ]
    },
    "critique_all": {
      "query_param_val": "critique_all",
      "filter_class": [
        "openForCritique",
        "openForSubmission"
      ]
    },
    "voting_closed": {
      "query_param_val": "voting_closed",
      "filter_class": [
        "votingClosed"
      ]
    },
    "coming_soon": {
      "query_param_val": "coming_soon",
      "filter_class": [
        "comingSoon"
      ]
    },
    "vote": {
      "query_param_val": "vote",
      "filter_class": [
        "inVoting"
      ]
    },
    "winners_announced": {
      "query_param_val": "winners_announced",
      "filter_class": [
        "winnersAnnounced",
        "votingClosed"
      ]
    }
  }
};

return {};

});

